import { useState } from "react";
import { toast } from "sonner";
import API, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/ui-bits";
import { Loader2, KeyRound } from "lucide-react";

const field = "w-full rounded-xl bg-white/5 border border-white/10 px-4 py-3 text-white outline-none focus:border-emerald-500/50";

export default function Account() {
  const { user } = useAuth();
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (f.new_password !== f.confirm) return toast.error("New passwords do not match");
    setBusy(true);
    try {
      await API.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      toast.success("Password updated");
      setF({ current_password: "", new_password: "", confirm: "" });
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };

  return (
    <div>
      <PageHeader title="Account" subtitle="Manage your profile details and password." testid="account-header" />
      <div className="grid lg:grid-cols-2 gap-6">
        <div className="glass rounded-2xl p-6">
          <h3 className="font-display text-lg font-semibold text-white mb-4">Profile</h3>
          <div className="space-y-3 text-sm">
            <Row label="Name" value={user.name} />
            <Row label="Email" value={user.email} />
            <Row label="Mobile" value={user.mobile} />
            <Row label="Country" value={user.country} />
            <Row label="Referral code" value={<span className="font-num text-emerald-300">{user.referral_code}</span>} />
            <Row label="Sponsor code" value={<span className="font-num">{user.sponsor_code || "—"}</span>} />
          </div>
        </div>

        <div className="glass rounded-2xl p-6">
          <h3 className="font-display text-lg font-semibold text-white flex items-center gap-2 mb-4"><KeyRound className="h-5 w-5 text-emerald-400" /> Change Password</h3>
          <div className="space-y-3">
            <input data-testid="current-password" type="password" placeholder="Current password" className={field} value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} />
            <input data-testid="new-password" type="password" placeholder="New password" className={field} value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} />
            <input data-testid="confirm-password" type="password" placeholder="Confirm new password" className={field} value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} />
            <button data-testid="change-password-btn" disabled={busy} onClick={submit}
              className="w-full inline-flex items-center justify-center gap-2 bg-emerald-500 hover:bg-emerald-400 disabled:opacity-60 text-slate-900 font-semibold py-3 rounded-xl">
              {busy && <Loader2 className="h-4 w-4 animate-spin" />} Update Password
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

const Row = ({ label, value }) => (
  <div className="flex items-center justify-between py-1.5 border-b border-white/5 last:border-0"><span className="text-slate-400">{label}</span><span className="text-white">{value}</span></div>
);
